import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "7ecec07f-8763-4e39-bd60-cb066e943b52",
    authority: "https://login.microsoftonline.com/bf86fbdb-f8c2-440e-923c-05a60dc2bc9b",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  }
};

export const loginRequest = {
    scopes: ["openid", "profile", "email"]
};

export const apiRequest = {
    scopes: ["api://7ecec07f-8763-4e39-bd60-cb066e943b52/access_as_user"]
};

export const msalInstance = new PublicClientApplication(msalConfig);




// WEBPACK FOOTER //
// ./src/auth/msalConfig.js